import styled from "styled-components";

const PaginatorPageSize = ({
  limit,
  setLimit,
  setPage,
  options = [5, 10, 15],
}) => {
  return (
    <ContainerPaginatorPageSize>
      <label htmlFor="PaginatorPageSizeSelect" className="page_size_label">
        Page Size:
      </label>
      <select
        id="PaginatorPageSizeSelect"
        className="page_size_select"
        value={limit}
        onChange={(e) => {
          setPage(1);
          setLimit(Number(e.target.value));
        }}
      >
        {options.map((size) => (
          <option key={size} value={size} className="page_size_option">
            {size}
          </option>
        ))}
      </select>
    </ContainerPaginatorPageSize>
  );
};

export default PaginatorPageSize;

const ContainerPaginatorPageSize = styled.div`
  flex: 0 0 auto;
  margin-left: auto;

  .page_size_label {
    font-weight: 600;
    margin-right: 5px;
  }

  .page_size_select {
    font-weight: 600;
    font-size: 14px;
    color: #f90;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    padding: 2px 6px;
  }

  .page_size_select:hover {
    border-color: #f90;
  }

  .page_size_select:focus {
    border-color: #f90;
    box-shadow: 0 0 5px #f90;
  }

  .page_size_option {
    font-weight: 600;
  }
`;
